import React from "react";
import {
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemState,
} from "react-accessible-accordion";
import { ReactComponent as ArrowDown } from "assets/img/icons/arrowdown.svg";
import { ReactComponent as ArrowUp } from "assets/img/icons/arrowup.svg";

export default ({ children, className }) => {
  return (
    <AccordionItemHeading>
      <AccordionItemButton className={className}>
        {children}

        <AccordionItemState>
          {({ expanded }) =>
            expanded ? (
              <ArrowDown className="accordionIcon" />
            ) : (
              <ArrowUp className="accordionIcon" />
            )
          }
        </AccordionItemState>
      </AccordionItemButton>
    </AccordionItemHeading>
  );
};
